import { createScopedDescriptor } from 'quartz/globalState/api';
export const INTERNAL_TRACKING_CONTEXT = createScopedDescriptor('internalTrackingContext', 'EXECUTION_CONTEXT');